import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractVisbosComponent} from '../../../../core/visbos-core/components/abstract-visbos.component';
import {SessionActions} from '../../../../shared/actions';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {InvoiceService} from '../../../services/invoice/invoice.service';
import {AccountingUnit} from '../../../../shared/view-model/crm/accounting-unit.type';
import {MessageType} from '../../../../shared/redux-store/session';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'vb-generate-invoice-view',
  templateUrl: './generate-invoice-view.component.html',
  styleUrls: ['./generate-invoice-view.component.css']
})
export class GenerateInvoiceViewComponent extends AbstractVisbosComponent implements OnInit {

  invoiceDataControl: FormGroup;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef, private fb: FormBuilder,
              private router: Router, private route: ActivatedRoute,
              private invoiceService: InvoiceService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    this.invoiceDataControl = this.fb.group({
      accountingUnitId: [null, Validators.required],
      accountingUnitType: [null, Validators.required],
      start: [null],
      end: [null],
      invoiceData: this.fb.group({
        administration_unit_id: [null]
      }),
      aggregateData: [null]
    });
  }

  onAccountingUnitSelected(accountingUnit: AccountingUnit) {
    if (this.invoiceDataControl) {
      this.invoiceDataControl.patchValue({
        accountingUnitType: accountingUnit ? accountingUnit.__typename : null
      });
    }
  }

  onGenerateInvoiceClicked() {
    this.invoiceDataControl.patchValue({invoiceData: {administration_unit_id: this.activeAdminUnitCuid}});
    this.invoiceService.generateInvoice(this.invoiceDataControl.value).subscribe(
      (res) => {
        this.sessionActions.pushMessage("Die Rechnung wurde erfolgreich erzeugt!", MessageType.SUCCESS, "Rechnungsstellung");
        this.router.navigate(['../', res.data.createInvoice.cuid], {relativeTo: this.route});
      }, err => {
        this.sessionActions.pushMessage("Fehler beim Erzeugen der Rechnung!", MessageType.ERROR, "Rechnungsstellung");
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/views/generate-invoice-view/generate-invoice-view.component.ts